// extracted by mini-css-extract-plugin
export default {"privacyPolicy":"PrivacyPolicy_privacyPolicy__Qd7OT","copirigth":"PrivacyPolicy_copirigth__qMg5Z","groupText":"PrivacyPolicy_groupText__Ge8Sx"};